import React from "react";

export default function LoaderOverlay({ show }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="relative w-24 h-24 flex items-center justify-center">
        <div className="absolute inset-0 border-4 border-gray-900 border-t-transparent rounded-full animate-spin-slow"></div>
        <img
          src="https://checkout.wurq.io/img_1.png"
          alt="Loading"
          className="h-16 w-auto object-contain"
        />
      </div>
    </div>
  );
}
